<div class="table-wrapper">
  <div class="table-scroll">
    <table class="data-table">
      <thead>
        <tr>
          @for (column of columns(); track trackByColumn($index, column)) {
            <th [class.col-fixed]="isColFixed(column)">{{ column.header }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of paginatedData; track trackById($index, row)) {
          <tr>
            @for (column of columns(); track trackByColumn($index, column)) {
              <td [class.col-fixed]="isColFixed(column)">
                @switch (column.type) {
                  @case ('boolean') {
                    <span [class.boolean-yes]="row[column.key]" [class.boolean-no]="!row[column.key]">
                      {{ row[column.key] ? ('common.yes' | translate) : ('common.no' | translate) }}
                    </span>
                  }
                  @case ('actions') {
                    <div class="action-buttons">
                      @for (action of getActionsForRow(row); track trackByAction($index, action)) {
                        <button
                          class="action-btn"
                          [ngClass]="getActionColorClass(action)"
                          [matTooltip]="action.label"
                          matTooltipPosition="above"
                          (click)="onActionClick(action, row)"
                          [attr.aria-label]="action.label"
                        >
                          <mat-icon>{{ action.icon }}</mat-icon>
                        </button>
                      }
                    </div>
                  }
                  @case ('money') {
                    <span [ngStyle]="getCellStyle(column, row[column.key])" [class.cell-badge]="hasHighlight(column, row[column.key])">
                      {{ formatCell(row[column.key], column.type) }}
                    </span>
                  }
                  @case ('date') {
                    <span [ngStyle]="getCellStyle(column, row[column.key])" [class.cell-badge]="hasHighlight(column, row[column.key])">
                      {{ formatCell(row[column.key], column.type) }}
                    </span>
                  }
                  @default {
                    <span [ngStyle]="getCellStyle(column, row[column.key])" [class.cell-badge]="hasHighlight(column, row[column.key])">
                      {{ row[column.key] }}
                    </span>
                  }
                }
              </td>
            }
          </tr>
        } @empty {
          <tr>
            <td [attr.colspan]="columns().length" class="empty-state">
              {{ 'common.noData' | translate }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (showPagination()) {
    <app-paginator
      [page]="page()"
      [total]="total()"
      [pageSize]="pageSize()"
      [setPage]="(page) => onPageChange(page)"
      [setPageSize]="(size) => onPageSizeChange(size)"
      labelSingular="fila"
      labelPlural="filas"
    />
  }
</div>
